declare var swal: any;
import { Component, OnInit } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../../animations/router.animations';
import { NgbModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CounsellingActivityController, CounsellingPlanController, CounsellingPlanRequest, CounsellingActivitiesByTimeController, CounsellingActivitiesByTimeRequest, SaveCounsellingActivityRequest, TreatmentCyclesController, TreatmentCyclesRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { CounsellingActivityRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbEditActivityMonitoringModal } from '../../follow up/activitytracking/activitymonitoringmodal/editactivitymonitoring.modal';
import { NgbcryostorageModal } from './cryostorage.modal';
//import { NgbActivityMonitoringModal } from './activitymonitoringmodal/activitymonitoring.modal';
//import { NgbEditActivityMonitoringModal } from '../../../../../../activitymonitoringmodal/editactivitymonitoring.modal';
//import { NgbEditActivityMonitoringModal } from './activitymonitoringmodal/editactivitymonitoring.modal';
//import { NgbCounsellingRegistryModal } from './modal/counsellingregistry.modal';
@Component({
  selector: 'app-freezing',
  templateUrl: './freezing.component.html',
  styleUrls: ['./freezing.component.css']
})
export class FreezingComponent implements OnInit {

  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }

  public ActorCode: number = 0;
  public diff: number = 0;
  public Add: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsToday: boolean = false;
  public IsDuration: boolean = true;
  public IsExpand: boolean = true;
  public isRequesting: boolean = false;
  public ShowMonitoring: boolean = false;
  public ShowTracking: boolean = true;
  public Showarrow: boolean = false;
  public ShowCryoList: boolean = true;
  public ShowCryoDetail: boolean = false;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;
  SelectedToDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  dateI: NgbDateStruct;
  TodayDate = new Date();
  Datediffer = new Date();


  sub: Subscription;
    CurrentTreatmentCyclesController: TreatmentCyclesController[];
    CurrentTreatmentCyclesRequest: TreatmentCyclesRequest;
    LoadPatients() {
        this.CurrentTreatmentCyclesRequest = new TreatmentCyclesRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCyclesRequest.Branch = 0;
        this.CurrentTreatmentCyclesRequest.ConditionalOperator = 10;
        this.CurrentTreatmentCyclesRequest.FromDate = new Date();
        this.CurrentTreatmentCyclesRequest.ToDate = new Date();
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCyclesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCyclesController();
    }

    GetTreatmentCyclesController() {
        this.StartRefreshing();


        this.actorservice.GetTreatmentCyclesController(this.CurrentTreatmentCyclesRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCyclesController = this.ApiResData.Result;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private actorservice:ActorService,
    private modalService: NgbModal,
    private parserFormatter: NgbDateParserFormatter,
    private route: ActivatedRoute,
    private loginservice: LoginService) { }
  ngOnInit() {
    //this.RefreshPatientsByDate();
    this.LoadPatients();
  ;
    this.SelectedToDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 2, day: this.TodayDate.getDate() };
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() - 1, day: this.TodayDate.getDate() };


  }
 
 

  ShowList: boolean = true;

  
  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }
  
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  BackToActivities() {
    this.ShowTracking = true;
    this.ShowMonitoring = false;
    this.Showarrow = false;
  }
 
  AddPlan() {
    this.ShowMonitoring = true;
    this.ShowTracking = false;
  }
  
  DecrementDate(Value: any) {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var d: Date = new Date(
      this.SelectedFromDate.year,
      this.SelectedFromDate.month,
      this.SelectedFromDate.day
    );
      //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
//    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

  //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth(), day: d.getDate()  };
   // this.RefreshPatientsByDate();
    //ind++;
  }
  IncrementDate(Value: any) {
      //this.dateI = new Date();
      //var i = this.dateI.valueOf() + 86400000;
      //this.dateI = new Date(i);
      //this.SelectedFromDate = dateI;
      //var ind: number = 0;
      //this.diff = this.diff - 1;
      //alert(this.diff);
      var d: Date = new Date(
        this.SelectedFromDate.year,
        this.SelectedFromDate.month,
        this.SelectedFromDate.day
      );
      //this.parserFormatter.parse(this.SelectedFromDate).;

      d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
      //    d.getFullYear
      //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

      //  this.SelectedFromDate = this.SelectedFromDate.
      this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth(), day: d.getDate() };
     // this.RefreshPatientsByDate();
      //ind++;
  }
BackToIvfWorkBench(){
  this.router.navigate(['healins/ivfworkbench']);
    }
    Selectedpatient: TreatmentCyclesController;
    OpenCryo(objCategory: any) {
        var patient: TreatmentCyclesController = objCategory;
        if (patient != null) {
            this.Selectedpatient = patient;          
            this.ShowCryoDetail = true;
            this.ShowCryoList = false;
        }
        else {
            this.Selectedpatient = null;
        }
    
      //this.router.navigate(['healins/Cryo2']);
  }
  BackToList() {
    this.ShowCryoDetail = false;
    this.ShowCryoList = true;
  }
  DisplayPatient() {
    const modalRef = this.modalService.open(NgbcryostorageModal,
      {
        centered: true,
        size: 'lg'
      })
  }
}

